import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const SendIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Send</title>
    <polygon points="42 24 6 10 13 22 28 24 13 26 6 38 42 24"/>
  </IconBase>
);
